import FcmsDevicesList from './device.list';
import PhoneAndroid from '@material-ui/icons/PhoneAndroid';

export default {
  name: 'devices/fcm',
  options: { label: 'Fcm Devices' },
  list: FcmsDevicesList,
  icon: PhoneAndroid
};
